export const SESSION_STORAGE_KEYS = {
  STATE: 'state'
} as const

export const DOMAINS = {
  CHINA: 'cn',
  GLOBAL: 'com'
} as const

export const COUNTRY_CODES = {
  CHINA: 'CN',
  CANADA: 'CA',
  UNITEDSTATES: 'US',
  AUSTRALIA: 'AU',
  TURKEY: 'TR',
  KOREA: 'KR',
  INDIA: 'IN',
  GERMANY: 'DE',
  DENMARK: 'DK'
} as const

export const ROUTES = {
  DASHBOARD: '/dashboard',
  PRIVACY: '/dashboard/privacy',
  CONFIRMATION: '/dashboard/privacy/confirmation',
  MARKETING_NOTICE: '/dashboard/privacy/marketing-notice-detail',
  CUSTOMIZATION: '/dashboard/privacy/customization-service',
  CUSTOMIZATION_DETAILS: '/dashboard/privacy/customization-service/details',
  CUSTOMIZATION_WITHDRAW: '/dashboard/privacy/customization-service/withdraw',
  CUSTOMIZATION_RECEIVE: '/dashboard/privacy/customization-service/receive',
  PESONALIZED_AD_WITHDRAW: '/dashboard/privacy/personalized/advertising/withdraw',
  PESONALIZED_AD_RECEIVE: '/dashboard/privacy/personalized/advertising/receive',
  PRIVACY_NOTICE: '/policies/privacy-notices/latest',
  PASSKEYS: '/dashboard/security/passkeys',
  SECURITY_ACTIVITIES: '/dashboard/security/activities',
  SECURITY_PHONE: '/dashboard/security/phone',
  SECURITY_RECOVERY: '/dashboard/security/recovery',
  SECURITY_2SV_VERIFICATION: '/dashboard/security/two-step-verification',
  RESET_PWD: '/dashboard/security/reset-password',
  REGISTER_PWD: '/dashboard/register-password',
  RESET_PWD_CONFIRM_ORGANIZER: '/dashboard/security/reset-password/confirm-organizer'
}

export const API_ENDPOINTS = {
  PROFILE: '/v1/profile',
  PROFILE_PREFERENCES: '/v1/profile/preferences',
  PWD_STATUS: '/credentials/passwords',
  V3_SECURITY_ACTIVITY: '/v3/security/activity/latest?limit=20'
}

export const EVENT_KEYS = {
  ENTER: 'Enter',
  SPACE: ' '
}
